//import config from '@/config'
//import axios from "axios";

class AuthService {
    constructor() {    
    }
    getOrgToken(){
        let orgList = this.getUserOrganization();
        if(orgList.length > 1 ){
            let isBrockerDealer  = window.location.pathname.includes('brockerdealer');
            if(isBrockerDealer){
                var isBrockerDealerOrg = orgList.find(function(org) {
                    return org.orgName === "newedge";
                });

                return  isBrockerDealerOrg ? isBrockerDealerOrg.orgToken : localStorage.getItem("org-token");

            }else{
                return localStorage.getItem("org-token");
            }


        }else{
            return localStorage.getItem("org-token");
        }
    }
    setOrgToken(token){
        localStorage.setItem("org-token", token);
    }
    removeOrgToken(){
        localStorage.removeItem("org-token");
    } 
    setModule(modules){
        const result = [] 
        modules.map(module => result.push(module.name));
        localStorage.setItem("module", JSON.stringify(result));
    }
    getModule(){
        return JSON.parse(localStorage.getItem("module"));
    }
    removeModule(){
        localStorage.removeItem("module");
    }
    setUser(user){
        localStorage.setItem("user", JSON.stringify(user));
    }
    setUserOrganization(org){
        localStorage.setItem("user-organization", JSON.stringify(org));
    }
    getUserOrganization(){
        return JSON.parse(localStorage.getItem("user-organization"));
    }
    getUser(){
        return JSON.parse(localStorage.getItem("user"));
    }
    removeUser(){
        localStorage.removeItem("user");
    }
    removeFcmToken(){
        localStorage.removeItem("fcmtoken");
    }
    getCurrentUserRoles(){
        let user = JSON.parse(localStorage.getItem("user"));
        let roleNames = user.userGroups.map(item => {
            return  item.split("-")[1];
        });
        return roleNames || [];

    }
  
  }
  export default new AuthService();